<style lang="scss" src="./_scss/inputWrap.scss"></style>
<template>
    <div class="ipt_wrap">
        <div class="wrap">
            <!-- 置灰加disabled -->
            <input type="text"
              v-model="input_cdkey"
              v-maxlength:input_cdkey="20"
              spellcheck="false"
              class="ipt ipt_txt"
              :disabled="!is_login"
              :placeholder="cdkey_input_placeholder"
              v-report.click="{f_hottag:'mod_cdkinput',f_module:'cdk输入框',f_type:3,f_resource:is_login?'已登录':'未登录'}">
            <div class="error" v-if="redeem_error">{{redeem_error}}</div>
        </div>
        <div class="wrap" v-if="is_login && phone">
            <div class="txt">{{$lang[13]}}: {{area_code}} {{phone}}</div>
            <div class="ipt_wrap" v-show="is_first">
                <input type="text" class="ipt ipt_code" v-model="input_code"
                  v-maxlength:input_code="4"
                  spellcheck="false"/>
                <b class="count_down" @click="sendCode">{{codeBtnText}}</b>
            </div>
            <div class="error" v-if="sendCodeErrorMsg">{{sendCodeErrorMsg}}</div>
        </div>
        <!-- 未绑定手机号 -->
        <div class="wrap" v-if="is_login && !phone">
            <p class="tips">
              {{$lang[11]}}
              <a href="javascript:void(0);" class="link" @click="toBind">{{$lang[12]}} ></a>
            </p>
        </div>
    </div>
</template>

<script type="text/ecmascript">
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import util from '@tencent/vft-common/util';

import { CAPTCHA_CODE } from 'src/config';
import { redeem,  sendOtpCode } from 'src/service/vipService';
import { callShield, testAlert } from 'src/util/index';

// 发送验证码接口错误码
const sendPhoneCodeErrorCode = {
  wrongParams: 4000,  // 请求参数错误
  frequencyLimit: 4029,   // 频率控制
  innerError: 5000,   // 内部错误
};

export default {
  data() {
    return {
      input_cdkey: '',
      input_code: '',
      sendCountdownTime: 0,
      sendCodeErrorMsg: '',
      sendSuccessTime: 0,
      sendTimerId: 0,
    };
  },
  async mounted() {
    const cdk = util.getUrlParam('cdk');
    if (cdk && /^\w+$/g.test(cdk) && cdk.length < 20) {
      this.input_cdkey = cdk;
    }

    // 账号有问题返回：4008 该cdkey被限制兑换
    // 没找到批次号返回：1010  请确认输入是否正确,注意大小写
    // 核销的时候没找到cdk返回：4012 请确认输入是否正确,注意区分大小写
    // 先查批次对不对，再查cdk对不对
    this.redeem_errors = {
      2002: this.$lang[22],
      1010: this.$lang[21],
      3005: this.$lang[17],
      3006: this.$lang[30],
      3019: this.$lang[19],
      3020: this.$lang[19],
      3021: this.$lang[19],
      4005: this.$lang[19],
      4006: this.$lang[19],
      4007: this.$lang[20],
      4008: this.$lang[21],
      4012: this.$lang[21],
    };

    this.$watch(() => this.$store.state.reset_flag, () => {
      this.input_cdkey = '';
      this.input_code = '';
      clearInterval(this.sendTimerId);
      this.sendCountdownTime = 0;
      this.sendCodeErrorMsg = '';
    });

    this.$watch(() => this.$store.state.redeem_flag, () => {
      this.sendCodeErrorMsg = '';

      this.$store.commit('setState', {
        state: 'redeem_error',
        value: '',
      });
      const cdkey = this.input_cdkey;
      let code = this.input_code;
      if (!this.$store.state.is_first) {
        code = '1111';
      }
      if (!cdkey) {
        this.$store.commit('setState', {
          state: 'redeem_error',
          value: this.$lang[40],
        });
      }
      if (!code) {
        this.sendCodeErrorMsg = this.$lang[41];
      }
      if (cdkey && code) {
        const captcha = new window.TencentCaptcha(CAPTCHA_CODE, async (res) => {
          if (+res.ret === 0) {
            const captchaRandStr = res.randstr;
            const captchaTicket = res.ticket;

            const resp = await redeem(
              this.appid,
              cdkey,
              captchaRandStr,
              captchaTicket,
              this.phone,
              code,
              this.area_code,
            );
            testAlert('redeem cgi', resp);

            if (!resp) {
              this.$store.commit('setState', {
                state: 'redeem_error',
                value: this.$lang[18],
              });
              return;
            }

            if (+resp.result.code === 0) {
              this.$store.commit('setState', {
                state: 'redeem_succ',
                value: true,
              });
              setTimeout(async () => {
                if (env.isApp) {
                  await atom.invoke('refreshVipInfo');
                }
                this.$store.dispatch('getUserInfo');
                this.$store.dispatch('checkIsFirst');
              }, 2000);
            } else {
              const err = this.redeem_errors[resp.result.code] || this.$lang[18];
              if (+resp.result.code === 3006) {
                this.sendCodeErrorMsg = err;
              } else {
                this.$store.commit('setState', {
                  state: 'redeem_error',
                  value: err,
                });
              }
            }
          } else {
            this.$store.commit('setState', {
              state: 'redeem_error',
              value: res.msg,
            });
          }
        });
        captcha.show();
      }
    });
  },
  computed: {
    ...mapGetters(['appid']),
    is_login() {
      return this.$store.state.is_login;
    },
    is_vip() {
      return this.$store.state.is_vip;
    },
    phone() {
      return this.$store.state.phone;
    },
    area_code() {
      return this.$store.state.area_code;
    },
    is_first() {
      return this.$store.state.is_first;
    },
    redeem_error() {
      return this.$store.state.redeem_error;
    },
    cdkey_input_placeholder() {
      if (this.$store.state.is_login) {
        return this.$lang[10];
      }
      return this.$lang[27];
    },
    codeBtnText() {
      if (this.sendCountdownTime === 0) {
        return this.$lang[15];
      }
      return this.sendCountdownTime + this.$lang[31];
    },
  },
  methods: {
    async sendCode() {
      if (this.sendCountdownTime) return;
      let res = null;
      this.sendCodeErrorMsg = '';
      if (env.isWetv) {
        let sendCodeRes = {};
        try {
          sendCodeRes = await atom.invoke('sendMobileCode', {
            areacode: this.area_code,
            phone: this.phone,
            scene: 'cdkey',
          });
        } catch (err) {
          const { errCode, errMsg } = err;
          sendCodeRes = {
            errCode,
            errMsg,
          };
        }
        res = {
          ret: sendCodeRes.errCode || 0,
          msg: sendCodeRes.errMsg,
        };
      } else {
        const sendCodeRes = await sendOtpCode(this.area_code, this.phone, 'cdkey');
        console.log(sendCodeRes);
        res = {
          ret: sendCodeRes.ret || sendCodeRes.data.code || 0,
          msg: sendCodeRes.msg || sendCodeRes.data.msg || '',
          safe_result: sendCodeRes.safe_result || '',
        };
      }
      if (res.ret !== 0) {
        this.errorHandler(res);
        return;
      }
      this.sendCountdownTime = 60;
      this.sendSuccessTime = res.timestamp;
      this.sendTimerId = setInterval(() => {
        this.sendCountdownTime -= 1;
        if (this.sendCountdownTime <= 0) {
          clearInterval(this.sendTimerId);
          this.sendCountdownTime = 0;
        }
      }, 1000);
    },
    async errorHandler(res) {
      const needCallShield = [15030, 15031].includes(res.ret);
      const isFrequencyLimit = res.ret === sendPhoneCodeErrorCode.frequencyLimit;
      if (needCallShield) {
        // 拉起防水墙
        await callShield(res);
        this.sendCode();
        return;
      }
      if (isFrequencyLimit) {
        // eslint-disable-next-line prefer-destructuring
        this.sendCodeErrorMsg = this.$lang[37];
        return;
      }
      // eslint-disable-next-line prefer-destructuring
      this.sendCodeErrorMsg = this.$lang[23];
    },
  },
};
</script>
